import { COLORS } from 'muiTheme/colors';
import type * as React from 'react';
const SvgIcoGridResize = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x={1} y={1} width={5.99202} height={6} fill="white" stroke={COLORS.HoverNFocus} strokeWidth={2} rx={1.2} />
  </svg>
);
export default SvgIcoGridResize;
